import React from "react";
import PropTypes from "prop-types";
import Headline from "~/assets/js/components/Typography/Headline";

const DesktopFooterEntry = ({ heading, content }) => {
    return (
        <div className="desktop_footer__entry">
            <Headline className="desktop_footer__entry__header" size={6}>
                {heading}
            </Headline>

            <p className="desktop_footer__entry__content">{content}</p>
        </div>
    );
};

DesktopFooterEntry.propTypes = {
    heading: PropTypes.string,
    content: PropTypes.string,
};

export default DesktopFooterEntry;
